import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-mission',
    templateUrl: './mission.component.html',
    styleUrls: ['./mission.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MissionComponent {

  constructor() { }

}
